import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Uses localStorage
import { persistReducer, persistStore } from "redux-persist";

// Import slices
import OrdersSlice from "../reduxSlice/admin/OrdersSlice";
import UtilsSlice from "../utilsSlice/UtilsSlice";
// import ProductSlice from "../reduxSlice/admin/ProductSlice";
import CollactionSlice from "../reduxSlice/admin/CollactionSlice";
import CustomerSlice from "../reduxSlice/admin/CustomerSlice";
import PurchaseOderSlice from "../reduxSlice/admin/PurchaseOrderSlice";
import SingUpSlice from "../reduxSlice/SingIn&Singup/SingUpSlice";
import SingInSlice from "../reduxSlice/SingIn&Singup/SingInSlice";
import AdminSingInSlice from "../reduxSlice/SingIn&Singup/AdminSingInSlice";
import TagSlice from "../reduxSlice/admin/TagSlice";
import SupplierSlice from "../reduxSlice/admin/SupplierSlice";
// import ProductsSlice from "../reduxSlice/website/ProductsSlice";
import BlogCategorySlice from "../reduxSlice/admin/BlogCategorySlice";
import CartCountSlice from "../reduxSlice/website/CartSlice";
import BlogListSlice from "../reduxSlice/admin/BlogListSlice";
import WishlistSlice from "../reduxSlice/website/WishlistSlice";
import WebOrdersSlice from "../reduxSlice/website/WebOrdersSlice";
import getCategoriesFullDataSlice from "../reduxSlice/website/getCategoriesFullDataSlice";
import BrandSlice from "../reduxSlice/admin/BrandSlice";
import { lazy } from "react";
import ProductReviewSlice from "../reduxSlice/website/ProductReviewSlice";
import CustomerAddAddressSlice from "../reduxSlice/website/CustomerAddAddressSlice";
import AdminProductReviewSlice from "../reduxSlice/admin/ProductReviewSlice";
import getMappingListSlice from "../reduxSlice/admin/MappingSlice";
import PriceListSlice from "../reduxSlice/admin/PriceListSlice";
import PromotionalBannerSlice from "../reduxSlice/admin/PromotionalBannerSlice";
import updateCustomerReducer from "../reduxApi/SingIn&SingUp/updateCustomerApi";
import leadReducer from "../reduxSlice/admin/LeadSlice"
import dealReducer from "../reduxSlice/admin/DealSlice"
import clientReducer from "../reduxSlice/admin/ClientSlice"
import companyReducer from "../reduxSlice/admin/CompanySlice"
import taskMasterReducer from "../reduxSlice/admin/TaskMasterSlice"
import notesReducer from "../reduxSlice/admin/NotesSlice"
import walkReducer from "../reduxSlice/admin/WalkthroughSlice"
import quotesReducer from "../reduxSlice/admin/quoteSlice"
import productSlice from "../reduxSlice/admin/ProductSlice"
import cityReducer from "../reduxSlice/admin/CityListSlice"
import organisationReducer from "../reduxSlice/admin/OrgSlice"
import employeesReducer from "../reduxSlice/admin/EmployeesSlice"
import CategorySlice from "../reduxSlice/admin/CategorySlice";
import roleReducer from "../reduxSlice/admin/RoleSlice"
import vendorReducer from "../reduxSlice/admin/vendorSlice"
import salesOrderReducer from "../reduxSlice/admin/SalesOrderSlice"
import shadeReducer from "../reduxSlice/admin/ShadesSlice"
import termsReducer from "../reduxSlice/admin/TermsAndConditionsSlice"
import warehouseReducer from "../reduxSlice/admin/WarehouseSlice"
import motorReducer from "../reduxSlice/admin/MotorizationSlice"
import colourReducer from "../reduxSlice/admin/ColourSlice"
import WebUserCartSlice from "../reduxSlice/website/WebUserCartSlice"
import columnReducer from "../reduxSlice/admin/ColumnSlice"
import bomReducer from "../reduxSlice/admin/BomSlice"
import PreparejobcardReducer from "../reduxSlice/admin/PrepareJobCardSlice"
import JobCardReducer from "../reduxSlice/admin/JobCardSlice"
import VolumetricReducer from "../reduxSlice/admin/VolumetricSlice"
import rawMaterialReducer from "../reduxSlice/admin/RawMaterialSlice"
import rawMaterialCollectionReducer from "../reduxSlice/admin/RawMaterialCollectionSlice"
import productionBatchReducer from "../reduxSlice/admin/ProductionBatchSlice"
import tableMasterReducer from "../reduxSlice/admin/UserTableslice";
import LimsReducer from "../reduxSlice/admin/LimsSlice"
import MaterialRequestReducer from "../reduxSlice/admin/MaterialReqSlice"
import PrintingPlanReducer from "../reduxSlice/admin/PrintingPlanSlice"
import PrintingReducer from "../reduxSlice/admin/PrintingSlice"
import AssemblyReducer from "../reduxSlice/admin/AssemblySlice"
import ChannelCuttingReducer from "../reduxSlice/admin/ChannelCuttingSlice"
import FabricCuttingReducer from "../reduxSlice/admin/FabricCuttingSlice"

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["SingIn", "AdminSingIn", "Cart", "Wishlist"], // Only persist authentication slices
};

// Combine reducers
const rootReducer = combineReducers({
  orders: OrdersSlice,
  // products: ProductSlice,
  customers: CustomerSlice,
  collactions: CollactionSlice,
  category: CategorySlice,
  PurchaseOders: PurchaseOderSlice,
  utils: UtilsSlice,
  tags: TagSlice,
  Singup: SingUpSlice,
  SingIn: SingInSlice, // Persisted
  AdminSingIn: AdminSingInSlice, // Persisted
  Supplier: SupplierSlice,
  BlogCategory: BlogCategorySlice,
  // product: ProductsSlice,
  Cart: CartCountSlice,
  BlogList: BlogListSlice,
  Wishlist: WishlistSlice,
  order: WebOrdersSlice,
  CategoriesFullData: getCategoriesFullDataSlice,
  Brand: BrandSlice,
  ProductReviews: ProductReviewSlice,
  CustomerAddAddress: CustomerAddAddressSlice,
  AdminProductReview: AdminProductReviewSlice,
  MappingList: getMappingListSlice,
  PriceList: PriceListSlice,
  PromotionalBanner: PromotionalBannerSlice,
  updateCustomer: updateCustomerReducer,
  lead: leadReducer,
  deal: dealReducer,
  client: clientReducer,
  company: companyReducer,
  task: taskMasterReducer,
  note: notesReducer,
  walk: walkReducer,
  quote: quotesReducer,
  inventory: productSlice,
  city: cityReducer,
  organisation: organisationReducer,
  employees: employeesReducer,
  role: roleReducer,
  vendor: vendorReducer,
  salesOrder: salesOrderReducer,
  shade: shadeReducer,
  termsAndCondition: termsReducer,
  warehouse: warehouseReducer,
  motor: motorReducer,
  colour: colourReducer,
  CartProducts: WebUserCartSlice,
  column: columnReducer,
  bom: bomReducer,
  Preparejobcard: PreparejobcardReducer,
  JobCard: JobCardReducer,
  volumetric: VolumetricReducer,
  rawMaterial: rawMaterialReducer,
  rawMaterialCollection: rawMaterialCollectionReducer,
  tableMaster: tableMasterReducer,
  productionBatch: productionBatchReducer,
  materialRequest:MaterialRequestReducer,
  Lims:LimsReducer,
  printingPlan:PrintingPlanReducer,
  printing:PrintingReducer,
  assembly:AssemblyReducer,
  channelCutting:ChannelCuttingReducer,
  FabricCutting:FabricCuttingReducer,
});


const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Required to prevent serialization errors
    }),
});


// Create Persistor
export const persistor = persistStore(store);
